import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import moment from 'moment';

var Config = require('../../../config');

class DonationsModal extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.verifyCheck = this.verifyCheck.bind(this);
		this.sendData = this.sendData.bind(this);

		this.state = {
			show: false,
			donations:[],
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(id){

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'donors/get_donations?donor_id='+id, {
			method:'GET',
			headers:new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				
				this.setState({show:true, donations:[]});
				response.res.map((don)=>{
					var pending = '';
					don.pending_results.map((p, i)=>{
						pending += p.name+(i === don.pending_results.length - 1 ? '' : ', ');
					});


					this.setState({
						donations:[...this.state.donations, {
							donation_number: don.donation_number,
							date: moment(don.date).format('DD/MM/YYYY'),
							check: false,
							color: don.pending_results.length > 0 ? 'red' : '',
							extraction_type:don.extraction_type,
							donation_type: don.donation_type,
							pending_results: don.pending_results,
							pending: pending,
							donation_id:don.donation_id,
							extraction_lookup: don.extraction_lookup,
							sample_id: don.samples_id,
							offers_id: don.offers_id,
							donation_notes_id: don.donation_notes === null ? 0 : don.donation_notes.id,
							no_negatives:don.no_negatives
						}]
					});
				})

				this.setState({show:true});
			}
		});

		
	}

	handleClose(){
		this.setState({show: false,donations:[]});
	}

	verifyCheck(e, num){
		var check = e.target.checked;

		this.state.donations.map((don)=>{
			return don.donation_number === num ?
				don.check = check ? true : false
			: don.check = false
		});

		this.forceUpdate();

	}

	sendData(){
		var index = this.state.donations.findIndex(obj => obj.check);

		if(index !== -1){
			this.props.setDonation(this.state.donations[index]);
			this.handleClose();
		}else{
			swal('Error', 'Debe seleccionar una donación', 'error');
		}

	}

	render(){
		const {t} = this.props;

		return (
			<Modal bsSize="lg" show={this.state.show} onHide={this.handleClose} >
		       	<Modal.Header closeButton>
		        	<Modal.Title>Donaciones</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12 form-group">
		        			<Table hover>
		        				<thead>
		        					<tr>
			        					<th>No. Donación</th>
			        					<th>Fecha</th>
			        					<th>Pruebas Reactivas</th>
										<th>Resultados Pendientes</th>
			        					<th></th>
		        					</tr>
		        				</thead>
		        				<tbody>
		        					{this.state.donations.map((don, i)=>{
	        							return <tr key={i} 
	        							style={don.color !== '' ? {border:"3px solid "+don.color} : {}}>
	        								<td>{don.donation_number}</td>
	        								<td>{don.date}</td>
	        								<td>{don.no_negatives}</td>
											<td>
												{don.pending === '' ? 'Sin resultados pendientes' : don.pending}
											</td>
	        								<td>
												{don.pending !== '' &&
													<input type="checkbox" checked={don.check}
													onChange={(e) => this.verifyCheck(e, don.donation_number)}/>
												}
													
	        								</td>
	        							</tr>
	        						})}
		        				</tbody>
		        			</Table>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.select')}  onClick={this.sendData}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>
		)
	}


}

export default translate('translations')(DonationsModal)